import pick from 'lodash/pick';
import {
  createStripeAccount,
  updateStripeAccount,
  fetchStripeAccount,
} from '../../ducks/stripeConnectAccount.duck';
import { currentUserShowSuccess, fetchCurrentUser } from '../../ducks/user.duck';
import {
  REQUEST_GROUP_TEMPLATE_ID,
  STRIPE_ONBOARDING_RETURN_URL_SUCCESS,
  STRIPE_VERIFICATION_ACCEPTED_TEMPLATE_ID,
  STRIPE_VERIFICATION_DENIED_TEMPLATE_ID,
  STRIPE_VERIFICATION_LIMIT_REACHED_ADMIN_TEMPLATE_ID,
  STRIPE_VERIFICATION_LIMIT_REACHED_TEMPLATE_ID,
  USER_TYPE_RESTRICTED,
  USER_TYPE_VERIFIED,
} from '../../util/types';
import { updateProfile } from '../ProfileSettingsPage/ProfileSettingsPage.duck';
import { denormalisedResponseEntities, getStripeVerificationStatus } from '../../util/data';
import { onSingleMailApiCollection, updateUserApi } from '../../util/api';

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/StripePayoutPage/SET_INITIAL_VALUES';
export const SAVE_PAYOUT_DETAILS_REQUEST = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_REQUEST';
export const SAVE_PAYOUT_DETAILS_SUCCESS = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_SUCCESS';
export const SAVE_PAYOUT_DETAILS_ERROR = 'app/StripePayoutPage/SAVE_PAYOUT_DETAILS_ERROR';

// ================ Reducer ================ //

const initialState = {
  payoutDetailsSaveInProgress: false,
  payoutDetailsSaved: false,
  fromReturnURL: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SAVE_PAYOUT_DETAILS_REQUEST:
      return { ...state, payoutDetailsSaveInProgress: true };
    case SAVE_PAYOUT_DETAILS_ERROR:
      return { ...state, payoutDetailsSaveInProgress: false };
    case SAVE_PAYOUT_DETAILS_SUCCESS:
      return { ...state, payoutDetailsSaveInProgress: false, payoutDetailsSaved: true };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const savePayoutDetailsRequest = () => ({
  type: SAVE_PAYOUT_DETAILS_REQUEST,
});
export const savePayoutDetailsError = () => ({
  type: SAVE_PAYOUT_DETAILS_ERROR,
});
export const savePayoutDetailsSuccess = () => ({
  type: SAVE_PAYOUT_DETAILS_SUCCESS,
});

// ================ Thunks ================ //

export const savePayoutDetails = (values, isUpdateCall) => (dispatch, getState, sdk) => {
  const upsertThunk = isUpdateCall ? updateStripeAccount : createStripeAccount;
  dispatch(savePayoutDetailsRequest());

  return dispatch(upsertThunk(values, { expand: true }))
    .then(response => {
      dispatch(savePayoutDetailsSuccess());
      return response;
    })
    .catch(() => dispatch(savePayoutDetailsError()));
};

export const loadData = params => (dispatch, getState, sdk) => {
  const { returnURLType } = params || {};
  // Clear state so that previously loaded data is not visible
  // in case this page load fails.
  dispatch(setInitialValues());
  const fetchCurrentUserOptions = {
    updateHasListings: false,
    updateNotifications: false,
  };

  return dispatch(fetchCurrentUser(fetchCurrentUserOptions)).then(response => {
    const currentUser = getState().user.currentUser;
    const { stripeAccount, attributes, id } = currentUser || {};
    console.log('&&& Stripe payout page &&& => loadData');

    if (currentUser && stripeAccount) {
      console.log('&&& Stripe currentUser.stripeAccount &&& => loadData');
      // fetch stripe account of user
      dispatch(fetchStripeAccount());

      const { profile, email } = attributes || {};
      const { firstName, lastName, metadata } = profile || {};
      const { verification_attempts = 0, id_verification_status, manual_override_reason = null } =
        metadata || {};
      const current_verification_attempts = verification_attempts + 1;

      // Verify Badge of User When Added the Submit Form.
      if (
        returnURLType &&
        id_verification_status !== USER_TYPE_VERIFIED &&
        current_verification_attempts <= 4
      ) {
        console.log('&&& Verify Badge of User When Added the Submit Form. &&& => ');
        const stripeVerificationStatus = getStripeVerificationStatus(
          returnURLType,
          current_verification_attempts
        );

        const hasReachedRestrictionLimit =
          current_verification_attempts === 4 && stripeVerificationStatus === USER_TYPE_RESTRICTED;

        const data = {
          userEmail: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
          email,
          name: `${firstName} ${lastName}`,
          userName: `${firstName} ${lastName}`,
          remainingAttempts: Math.max(0, 4 - current_verification_attempts),
        };

        // const sendGridMailData = {
        //   data,
        //   template_id: hasReachedRestrictionLimit
        //     ? STRIPE_VERIFICATION_LIMIT_REACHED_TEMPLATE_ID
        //     : stripeVerificationStatus === USER_TYPE_VERIFIED
        //     ? STRIPE_VERIFICATION_ACCEPTED_TEMPLATE_ID
        //     : STRIPE_VERIFICATION_DENIED_TEMPLATE_ID,
        // };

        // onSingleMailApiCollection(sendGridMailData);

        // if (hasReachedRestrictionLimit) {
        //   // send email to admin when user reaches restriction limit
        //   onSingleMailApiCollection({
        //     data: {
        //       name: process.env.REACT_APP_SENDGRID_SENDER_NAME,
        //       email: process.env.REACT_APP_SENDGRID_ADMIN_RECIVER_EMAIL,
        //       userEmail: email,
        //       userName: `${firstName} ${lastName}`,
        //       userID: id?.uuid,
        //     },
        //     template_id: STRIPE_VERIFICATION_LIMIT_REACHED_ADMIN_TEMPLATE_ID,
        //   });
        // }

        updateUserApi({
          userId: id?.uuid,
          payload: {
            metadata: {
              id_verification_status: stripeVerificationStatus,
              verification_attempts: current_verification_attempts,
              ...(manual_override_reason === null ? { manual_override_reason: '' } : {}),
            },
          },
        }).then(res => {
          const entities = denormalisedResponseEntities(res);
          if (entities.length !== 1) {
            throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
          }
          const currentUser = entities[0];

          // Update current user in state.user.currentUser through user.duck.js
          dispatch(currentUserShowSuccess(currentUser));
        });

        console.log('&&& USER Verify Badge Added &&& => ');
      }
    }
    return response;
  });
};
